import React from "react";
export default function Heading(props) {
    return (
        <div className="col">
            <h1>{props.title}</h1>
        </div>
    );

}